import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../../custom-components/wrappers/page-wrapper/PageWrapper';
import css from './AuthRequiredGate.module.css';
import { POST_AUTH_REDIRECT_KEY } from '../../util/postAuthRedirect';

// Router-level auth gate: rendered by Routes.js in place of the real
// page whenever a logged-out visitor hits an `auth: true` route. Shows
// a blank page with a sign-up/login popup instead of the destination
// page, so nothing behind the gate is ever rendered for anonymous users.
// Styled after the SignupWall card on the What's New post page
// (src/containers/WhatsNewPage/WhatsNewPostPage.js).
const AuthRequiredGate = ({ from }) => {
  const saveBacklink = () => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(POST_AUTH_REDIRECT_KEY, from);
      }
    } catch (e) {
      // localStorage may be disabled — non-fatal.
    }
  };

  return (
    <PageWrapper title="Sign up — Viveka">
      <div className={css.page}>
        <div className={css.signupWallCard}>
          <div className={css.signupWallIcon}>🔓</div>
          <h2 className={css.signupWallHeading}>Sign up to explore Viveka</h2>
          <p className={css.signupWallText}>
            Create a free account to unlock this page and get full access to Viveka's coaching
            resources.
          </p>
          <Link to="/signup/coach" className={css.signupWallCta} onClick={saveBacklink}>
            Sign up — it's free
          </Link>
          <p className={css.signupWallLogin}>
            Already have an account?{' '}
            <Link to="/login" className={css.signupWallLoginLink} onClick={saveBacklink}>
              Log in
            </Link>
          </p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AuthRequiredGate;
